import Component from 'flarum/common/Component';
import app from 'flarum/forum/app';
import { icon } from './ui';
import { portalEvent, portalHome } from './portalApi';
export default class UserRoleBadge extends Component {
  role = null;
  sent = false;
  error = '';
  oninit(v) {
    super.oninit(v);
    portalHome().then(data => {
      this.role = (data.role_users || []).find(item => Number(item.user_id) === Number(this.attrs.userId));
      m.redraw();
    });
  }
  async reputation() {
    if (!app.session.user) {
      this.error = 'Zaloguj się';
      m.redraw();
      return;
    }
    try {
      await portalEvent({
        action: 'reputation',
        post_id: this.attrs.postId,
        user_id: this.attrs.userId,
        score: 1
      });
      this.sent = true;
      if (this.role) this.role.reputation = Number(this.role.reputation || 0) + 1;
    } catch (e) {
      this.error = 'Nie można ocenić';
    }
    m.redraw();
  }
  view() {
    const r = this.role || {};
    return m("span", {
      className: `NtUserRole NtNickEffect is-${r.effect || 'none'}`,
      style: {
        '--role-color': r.color || '#9ba3a9',
        '--role-bg': r.background || 'transparent',
        '--role-background': r.background || 'transparent'
      }
    }, r.name ? icon(r.icon || 'fas fa-shield-alt') : null, r.custom_title || r.short_name || r.name || 'Gracz', m("em", null, "+", r.reputation || 0), r.country_code ? m("b", null, r.country_code) : null, this.attrs.postId ? m("button", {
      disabled: this.sent,
      title: this.error || 'Przyznaj punkt reputacji',
      onclick: e => {
        e.preventDefault();
        this.reputation();
      }
    }, icon(this.sent ? 'fas fa-check' : 'fas fa-thumbs-up')) : null);
  }
}
flarum.reg.add('novatruck-theme', 'forum/components/UserRoleBadge', UserRoleBadge);